export const jobDetailsStatuses: Readonly<any> = {
    1: { text: 'Info' },
    2: { text: 'Warning' },
    3: { text: 'Error' },
    4: { text: 'Analysis' }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/jobDetailsStatuses.ts